import { ChartModule } from 'primeng/chart';
export default ChartModule;
